module.exports = __webpack_public_path__ + "static/img/fgbg2-6.af22de3.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/2/fgbg2-6.png
// module id = 197
// module chunks = 0